import React, { Component } from "react";
import SideBarsJsx from "./sidebar.jsx"
import axios from 'axios'
import {
  baseURL
} from "../../../../constants/applicationConstants.js";
import { Loader } from '../../../common/loader/loader.jsx';
export default class SideBars extends Component {
  constructor(props) {
    super(props);
    this.state = {
      responseData: null
    };
  }
  componentDidMount = () => {
    this.setState({ isLoading: true })
    let token = localStorage.getItem("token") && JSON.parse(localStorage.getItem("token"))
    let instituteId = localStorage.getItem("masterID") && JSON.parse(localStorage.getItem("masterID"))

    if (token && instituteId) {
      this.callDetails()
    }
  }
  callDetails = () => {
    let token = localStorage.getItem("token") && JSON.parse(localStorage.getItem("token"))
    let customerId = localStorage.getItem("masterID") && JSON.parse(localStorage.getItem("masterID"))
    axios.get(`${baseURL}/customer/${customerId}`, {
      headers: { 'x-access-token': token }
    }).then(res => {

      this.setState({ responseData: res.data.data })
      localStorage.setItem("legalName", res.data.data?.firstName);
      localStorage.setItem("planName", res.data.data?.planName);

      this.setState({ isLoading: false })
    }).catch(err => {
      this.setState({ isLoading: false })
    })
  }
  render() {
    return (
      <div>
        <SideBarsJsx
          response={this.state.responseData}
        />
        {this.state.isLoading && <Loader />}
      </div>
    );
  }
}

